<template>
    <div v-if="isExternal" :style="styleExternalIcon" class="svg-external-icon svg-icon" v-on="$listeners" />
    <svg v-else :class="svgClass" aria-hidden="true" v-on="$listeners">
        <use :xlink:href="iconName" />
    </svg>
</template>

<script>
import { isExternal } from '@common/utils/validate'

export default {
    name: 'SvgIcon',
    props: {
        name: {
            type: String,
            required: false,
        },
        iconClass: {
            type: String,
            required: false,
        },
        className: {
            type: String,
            default: '',
        },
        color: {
            type: String,
            default: '#989B9F',
        },
    },
    computed: {
        icon() {
            return this.iconClass || this.name
        },
        isExternal() {
            return isExternal(this.icon)
        },
        iconName() {
            return `#icon-${this.icon}`
        },
        svgClass() {
            if (this.className) {
                return `svg-icon ${this.className}`
            }
            return 'svg-icon'
        },
        styleExternalIcon() {
            return {
                mask: `url(${this.icon}) no-repeat 50% 50%`,
                '-webkit-mask': `url(${this.icon}) no-repeat 50% 50%`,
            }
        },
    },
}
</script>

<style scoped>
.svg-icon {
width: 1em;
height: 1em;
vertical-align: -0.15em;
fill: currentColor;
overflow: hidden;
}
.svg-external-icon {
background-color: currentColor;
mask-size: cover!important;
display: inline-block;
}
</style>
